/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_External_Directories_Cta_SubmitInputs */

const en_directory_external_directories_cta_submit = /** @type {(inputs: Directory_External_Directories_Cta_SubmitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Submit your tool`)
};

const zh_directory_external_directories_cta_submit = /** @type {(inputs: Directory_External_Directories_Cta_SubmitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`提交你的产品`)
};

/**
* | output |
* | --- |
* | "Submit your tool" |
*
* @param {Directory_External_Directories_Cta_SubmitInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_external_directories_cta_submit = /** @type {((inputs?: Directory_External_Directories_Cta_SubmitInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_External_Directories_Cta_SubmitInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_external_directories_cta_submit(inputs)
	return zh_directory_external_directories_cta_submit(inputs)
});
export { directory_external_directories_cta_submit as "directory.external_directories.cta.submit" }